var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',[_c('el-alert',{staticStyle:{"margin-bottom":"16px"},attrs:{"title":_vm.msg,"type":_vm.type,"show-icon":""},on:{"close":function($event){return _vm.$emit('hide-alert')}}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed29eb78","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/apps/bpm/designer/components/helpers/PanelAlert.vue
// module id = null
// module chunks = 